import { GridSortModel } from '@chronosphereio/chrono-ui';
import { calculationTypeSchema, LegendSpecOptions, legendSortOrderSchema } from '@/core';

export type LegendSortSpec = LegendSpecOptions['sort'];

function isValidLegendSortBy(fieldName: string): boolean {
  return calculationTypeSchema.safeParse(fieldName).success;
}

/**
 * Convert a grid sort model to the legend spec sort format.
 * Filters out any sorts with invalid field names.
 */
export function gridSortModelToSpecSort(model?: GridSortModel): LegendSortSpec | undefined {
  if (!model || model.length === 0) return undefined;

  const validSorts = model
    .map((muiSort) => {
      const convertedSortBy = muiSort.field.startsWith('data.') ? muiSort.field.split('.').pop() : muiSort.field;
      const sortOrder = muiSort.sort === 'asc' ? 'Asc' : 'Desc';
      return {
        sort_by: convertedSortBy ?? muiSort.field,
        sort_order: legendSortOrderSchema.parse(sortOrder),
      };
    })
    .filter((sort) => isValidLegendSortBy(sort.sort_by));

  return validSorts.length > 0 ? validSorts : undefined;
}

/**
 * Convert a legend spec sort format to the grid sort model.
 */
export function specSortToGridSortModel(spec?: LegendSortSpec): GridSortModel | undefined {
  if (!spec || spec.length === 0) return undefined;
  return spec.map((sort) => ({
    field: `data.${sort.sort_by}`,
    sort: sort.sort_order === 'Desc' ? 'desc' : 'asc',
  }));
}
